exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dropdown-menu[data-v-5e2f801d] {\n  min-width: 400px;\n}\n.btn-isco[data-v-5e2f801d], .btn-isco-reset[data-v-5e2f801d] {\n  margin-top: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-5e2f801d","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/DropDownSearchProfiles.vue
// module id = /Box
// module chunks = 97